import { ValueOf } from 'ts-pattern/dist/types/helpers'

export const ERROR_TRANSLATIONS = {
  OFFER_NOT_AVAILABLE: 'not_found',
  CUSTOMER_ACTIVE_RESERVATION_LIMIT_EXCEEDED: 'error_exceed_reservation_limit',
  CUSTOMER_PER_OFFER_RESERVATION_LIMIT_EXCEEDED:
    'error_exceed_reservation_limit',
  CUSTOMER_EXTRACTION_FAILED: 'not_found',
  STORE_CLOSED_FOR_RESERVATIONS: 'not_found',
  STORE_NOT_FOUND: 'not_found',
} as const

export type ErrorCodes = keyof typeof ERROR_TRANSLATIONS
export type ErrorMessageKey = ValueOf<typeof ERROR_TRANSLATIONS>

export interface ErrorResponse {
  code: ErrorCodes
  error: string
  message: ErrorMessageKey
}
